'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const MobileFooter = () => {

    const contactActions = [
        {
            icon: 'ChatBubbleLeftRightIcon',
            label: 'WhatsApp',
            href: 'https://wa.me/918686284396?text=Hi%20SitemapGenius...',
            color: 'bg-[#25D366]',
            textColor: 'text-white'
        },
        {
            icon: 'PhoneIcon',
            label: 'Call',
            href: 'tel:+918686284396',
            color: 'bg-indigo-600',
            textColor: 'text-white'
        },
        {
            icon: 'EnvelopeIcon',
            label: 'Email',
            href: 'mailto:sitemapgenius@gmail.com',
            color: 'bg-slate-100',
            textColor: 'text-slate-700'
        }
    ];

    const legal = [
        { label: 'Privacy', href: '/privacy' },
        { label: 'Terms', href: '/terms' },
        { label: 'Cookies', href: '/cookies' },
    ];

    return (
        <footer className="bg-white border-t border-slate-100 pb-32 pt-12">
            <div className="container mx-auto px-6">

                {/* Brand Header */}
                <div className="text-center mb-10">
                    <h3 className="text-xl font-bold text-slate-900 mb-1">
                        SitemapGenius
                    </h3>
                    <p className="text-xs text-slate-500 font-medium tracking-wide uppercase">
                        We Don't Just Build; We Elevate
                    </p>
                </div>

                {/* Hub Actions (Minimalist Icons) */}
                <div className="flex justify-center gap-4 mb-12">
                    {contactActions.map((action, i) => (
                        <a
                            key={i}
                            href={action.href}
                            target={action.href.startsWith('https') ? '_blank' : undefined}
                            rel="noopener noreferrer"
                            className="flex flex-col items-center gap-2 group"
                        >
                            <div className={`w-14 h-14 rounded-2xl ${action.color} ${action.textColor} flex items-center justify-center shadow-lg shadow-slate-200/50 transition-transform duration-200 group-active:scale-95`}>
                                <Icon name={action.icon as any} className="w-6 h-6" />
                            </div>
                            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{action.label}</span>
                        </a>
                    ))}
                </div>

                {/* Compact Legal & Copyright */}
                <div className="flex flex-col items-center gap-4 border-t border-slate-50 pt-8">

                    {/* Legal Links */}
                    <div className="flex gap-4">
                        {legal.map((link, i) => (
                            <a key={i} href={link.href} className="text-xs text-slate-400 font-medium hover:text-slate-600">
                                {link.label}
                            </a>
                        ))}
                    </div>

                    <div className="text-center space-y-1">
                        <p className="text-[10px] text-slate-300 font-medium hover:text-indigo-600 transition-colors duration-300 cursor-default">
                            &copy; 2022 SitemapGenius. All rights reserved.
                        </p>
                        <p className="text-xs text-slate-400 mt-2 flex items-center justify-center gap-1.5">
                            Designed & Developed by
                            <a href="https://instagram.com/abdulsohailsamad" target="_blank" className="inline-flex items-center gap-1.5 font-bold text-slate-500 hover:text-indigo-600 transition-colors group">
                                Abdul Sohail Samad
                                <svg className="w-3.5 h-3.5 group-hover:text-[#E1306C] transition-colors" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.468 2.53c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                                </svg>
                            </a>
                        </p>
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default MobileFooter;
